import React from 'react';
import { Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { Sort } from '../../../pages/DevicesPage/hooks/useDevicesFilter';

const { Option } = Select;

function ContentFilter({ className, sort, onSearch, onSort }) {
  const { t } = useTranslation();

  return (
    <div className={cn('content-filter', className)}>
      <Input.Search onChange={onSearch} placeholder={t('search-by-name')} />
      <Select value={sort} onSelect={onSort}>
        <Option key={Sort.NOVELTY} value={Sort.NOVELTY}>
          {t('search-by-novelty')}
        </Option>
        <Option key={Sort.ASC} value={Sort.ASC}>
          {t('search-by-alphabet')}
        </Option>
        <Option key={Sort.DESC} value={Sort.DESC}>
          {t('search-by-alphabet-reverse')}
        </Option>
      </Select>
    </div>
  );
}

export default ContentFilter;
